/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_SummaryInputs */

const en_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand position and pressure, alignment, and stance.`)
};

const es_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición y presión de las manos, alineación y stance.`)
};

const de_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handposition und -druck, Ausrichtung und Haltung.`)
};

const zh_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手的位置与握压、瞄准方向和站姿。`)
};

const ar_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وضع اليدين والضغط، والمحاذاة، ووضع الوقوف.`)
};

const fr_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position et pression des mains, alignement et posture.`)
};

const vi_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí tay, lực cầm gậy, căn chỉnh và stance.`)
};

const sw_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mkao na shinikizo la mikono, mpangilio wa mwelekeo, na msimamo.`)
};

const th_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตำแหน่งและแรงกดของมือ การจัดแนว และการยืน`)
};

const bs_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položaj i pritisak ruku, poravnanje i stance.`)
};

const ja_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手の位置とグリッププレッシャー、アライメント、スタンス。`)
};

const ko_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`손의 위치와 그립 압력, 정렬, 스탠스.`)
};

const pt_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição e pressão das mãos, alinhamento e postura.`)
};

const it_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione e pressione delle mani, allineamento e stance.`)
};

const sv_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handposition och tryck, linjering och stance.`)
};

const nl_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handpositie en -druk, uitlijning en stance.`)
};

const da_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Håndposition og tryk, linjering og stance.`)
};

const nb_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Håndposisjon og trykk, linjering og stance.`)
};

const fi_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsien asento ja paine, linjaus sekä asento.`)
};

const pl_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozycja i nacisk dłoni, ustawienie względem celu i postawa.`)
};

const ru_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Положение рук и давление хвата, направление и стойка.`)
};

const tr_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El pozisyonu ve baskısı, hizalama ve duruş.`)
};

const hi_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाथ की स्थिति और दबाव, एलाइनमेंट और स्टांस।`)
};

const id_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisi dan tekanan tangan, alignment, dan stance.`)
};

const ms_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kedudukan dan tekanan tangan, penjajaran dan kedudukan kaki.`)
};

const cs_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poloha rukou a tlak gripu, směrování a postoj.`)
};

const el_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Θέση και πίεση χεριών, ευθυγράμμιση και στάση.`)
};

const he_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מיקום הידיים ולחץ האחיזה, יישור ועמידה.`)
};

const af_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handposisie en druk, uitlyning en houding.`)
};

const hu_method_content_step_01_summary = /** @type {(inputs: Method_Content_Step_01_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kézhelyzet és nyomás, irányállítás és állás.`)
};

/**
* | output |
* | --- |
* | "Hand position and pressure, alignment, and stance." |
*
* @param {Method_Content_Step_01_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_summary = /** @type {((inputs?: Method_Content_Step_01_SummaryInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_SummaryInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_summary(inputs)
	if (locale === "de") return de_method_content_step_01_summary(inputs)
	if (locale === "zh") return zh_method_content_step_01_summary(inputs)
	if (locale === "ar") return ar_method_content_step_01_summary(inputs)
	if (locale === "fr") return fr_method_content_step_01_summary(inputs)
	if (locale === "vi") return vi_method_content_step_01_summary(inputs)
	if (locale === "sw") return sw_method_content_step_01_summary(inputs)
	if (locale === "th") return th_method_content_step_01_summary(inputs)
	if (locale === "bs") return bs_method_content_step_01_summary(inputs)
	if (locale === "ja") return ja_method_content_step_01_summary(inputs)
	if (locale === "ko") return ko_method_content_step_01_summary(inputs)
	if (locale === "pt") return pt_method_content_step_01_summary(inputs)
	if (locale === "it") return it_method_content_step_01_summary(inputs)
	if (locale === "sv") return sv_method_content_step_01_summary(inputs)
	if (locale === "nl") return nl_method_content_step_01_summary(inputs)
	if (locale === "da") return da_method_content_step_01_summary(inputs)
	if (locale === "nb") return nb_method_content_step_01_summary(inputs)
	if (locale === "fi") return fi_method_content_step_01_summary(inputs)
	if (locale === "pl") return pl_method_content_step_01_summary(inputs)
	if (locale === "ru") return ru_method_content_step_01_summary(inputs)
	if (locale === "tr") return tr_method_content_step_01_summary(inputs)
	if (locale === "hi") return hi_method_content_step_01_summary(inputs)
	if (locale === "id") return id_method_content_step_01_summary(inputs)
	if (locale === "ms") return ms_method_content_step_01_summary(inputs)
	if (locale === "cs") return cs_method_content_step_01_summary(inputs)
	if (locale === "el") return el_method_content_step_01_summary(inputs)
	if (locale === "he") return he_method_content_step_01_summary(inputs)
	if (locale === "af") return af_method_content_step_01_summary(inputs)
	if (locale === "hu") return hu_method_content_step_01_summary(inputs)
	return en_method_content_step_01_summary(inputs)
});